// components/ui/button.tsx
import * as React from "react"
import { cn } from "../../lib/shared/utils";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline';
}

export function buttonVariants(props: { variant?: 'default' | 'outline' } = {}) {
  return cn(
    "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
    props.variant === "outline" ? "border border-input bg-background hover:bg-accent hover:text-accent-foreground" 
                               : "bg-primary text-primary-foreground shadow hover:bg-primary/90"
  )
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"